import { Box, Grid, Stack, styled, Typography } from "@mui/material";
import communicTVImage from "../assets/communitvWireframes.png";
import historyHubImage from "../assets/historyhubWireframes.png";
import React from "react";
import teleTriviaImage from "../assets/teletriviaWireframes.png";
import Title from "./Title";
import Persona from "../assets/persona.png";
import Moderation from "../assets/Moderation.png";
import FeedLivestream from "../assets/FeedLivestream.png";
import Gamification from "../assets/Gamification.png";
import Samenvatting from "../assets/Samenvatting.png";
import Video from "../assets/Video.MP4";

const Overview = () => {
  const CustomGridItem = styled(Grid)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  });

  const CustomTypography = styled(Typography)({
    fontSize: "1.1rem",
    textAlign: "start",
    lineHeight: "1.5",
    color: "#515151",
    marginTop: "1.5rem",
  });

  return (
    <>
      <Typography variant="h4" mx={2} mt={2}>
        NPO Connect
      </Typography>

      <Typography mx={2} mt={2}>
        Na een aantal weken gewerkt te hebben aan het project voor de NPO, zijn wij als team Young
        Innovatie Thinkers tot een definitief concept gekomen genaamd NPO Connect. Maar wat is NPO
        Connect? Onderstaand vind je een hele uitleg over dit project. Verder op de one pager kun je
        ook onze andere concepten inzien.
      </Typography>

      <Grid
        container
        spacing={{ xs: 4, sm: 4, md: 0 }}
        sx={{
          py: 10,
          px: 2,
        }}
      >
        <CustomGridItem item xs={12} sm={8} md={6} component="section">
          <Box
            component="article"
            sx={{
              px: 4,
            }}
          >
            <Title text={"Introductie en Probleemstelling"} textAlign={"start"} />
            <CustomTypography>
              In een tijdperk waarin sociale media ons dagelijks overspoelen met wereldnieuws, lijkt
              het nieuws in onze eigen buurt vaak ondergesneeuwd te raken. Het resultaat? We missen
              cruciale gebeurtenissen en ontwikkelingen die direct invloed kunnen hebben op ons
              dagelijks leven. Of het nu gaat om een gestolen fiets of een lokale inbraak, het is
              essentieel om op de hoogte te blijven van wat er in onze directe omgeving gebeurt.
            </CustomTypography>
          </Box>
        </CustomGridItem>

        <Grid item xs={12} sm={4} md={6}></Grid>

        <Grid item xs={12} sm={4} md={6}>
          <img
            src={Persona}
            alt=""
            style={{
              width: "100%",
            }}
          />
        </Grid>
        <CustomGridItem item xs={12} sm={8} md={6} component="section">
          <Box
            component="article"
            sx={{
              px: 4,
            }}
          >
            <Title text={"Oplossing en Doelgroep"} textAlign={"start"} />
            <CustomTypography>
              NPO Connect biedt de oplossing. Speciaal ontworpen voor jongeren tussen de 16 en 25
              jaar, stelt deze app gebruikers in staat om verbonden te blijven met de gebeurtenissen
              binnen hun omgeving. Via NPO Connect kunnen gebruikers informatie delen en ontvangen
              over lokale gebeurtenissen in realtime. Het platform fungeert als een centrale hub
              waar nieuws en meningen kunnen worden gedeeld, waardoor een sterke lokale gemeenschap
              ontstaat. Gebruikers kunnen eenvoudig hun voorkeurslocaties instellen om relevant
              nieuws te ontvangen.
            </CustomTypography>
          </Box>
        </CustomGridItem>

        <CustomGridItem item xs={12} sm={8} md={6} component="section">
          <Box
            component="article"
            sx={{
              px: 4,
            }}
          >
            <Title text={"Wat maakt NPO Connect uniek?"} textAlign={"start"} />
            <CustomTypography>
              NPO Connect onderscheidt zich door betrouwbare en diverse nieuwsbronnen samen te
              brengen, waardoor gebruikers een breed scala aan perspectieven kunnen verkennen. Het
              platform biedt nieuws op een sociale-media-achtige manier aan, waardoor het
              aantrekkelijk is voor jongeren. Tegelijkertijd worden de risico's van eenzijdige of
              sensationele berichtgeving geminimaliseerd dankzij de moderatie door lokale derde
              partijen. Dit verzekert de kwaliteit en betrouwbaarheid van de geposte informatie.
            </CustomTypography>
          </Box>
        </CustomGridItem>

        <Grid item xs={12} sm={4} md={6}>
          <img
            src={FeedLivestream}
            alt=""
            style={{
              width: "100%",
            }}
          />
        </Grid>

        <Grid item xs={12} sm={4} md={6}>
          <img
            src={Moderation}
            alt=""
            style={{
              width: "100%",
            }}
          />
        </Grid>

        <CustomGridItem item xs={12} sm={8} md={6} component="section">
          <Box
            component="article"
            sx={{
              px: 4,
            }}
          >
            <Title text={"Moderatie en Betrouwbaarheid"} textAlign={"start"} />
            <CustomTypography>
              Moderatie wordt uitgevoerd door lokale bewoners die gepassioneerd zijn over de
              veiligheid van hun omgeving. Deze derde partijen worden gerekruteerd uit
              buurtpreventiegroepen en zorgen voor een hoogwaardige en betrouwbare informatiestroom.
              Geautomatiseerde moderatietools worden ook ingezet om de community te beheren en
              ongewenste inhoud te filteren.
            </CustomTypography>
          </Box>
        </CustomGridItem>

        <CustomGridItem item xs={12} sm={8} md={6} component="section">
          <Box
            component="article"
            sx={{
              px: 4,
            }}
          >
            <Title text={"Stimulatie van Gebruikersbetrokkenheid"} textAlign={"start"} />
            <CustomTypography>
              Om gebruikers aan te moedigen actief deel te nemen aan de community, biedt NPO Connect
              beloningen en erkenning binnen de app. Gebruikers kunnen badges verdienen en worden
              beloond voor hun bijdragen aan het platform. Door regelmatig te posten en veel likes
              te ontvangen, kunnen gebruikers een positie verwerven als betrouwbare en gewaardeerde
              leden van de gemeenschap, wat hun zichtbaarheid en invloed binnen de app vergroot.
            </CustomTypography>
          </Box>
        </CustomGridItem>

        <Grid item xs={12} sm={4} md={6}>
          <img
            src={Gamification}
            alt=""
            style={{
              width: "100%",
            }}
          />
        </Grid>

        <Grid item xs={12} sm={4} md={6}>
          <img
            src={Samenvatting}
            alt=""
            style={{
              width: "100%",
            }}
          />
        </Grid>

        <CustomGridItem item xs={12} sm={8} md={6} component="section">
          <Box
            component="article"
            sx={{
              px: 4,
            }}
          >
            <Title text={"Samenvatting"} textAlign={"start"} />
            <CustomTypography>
              NPO Connect is meer dan alleen een nieuwsapp; het is een platform dat jongeren
              verbindt met hun lokale gemeenschap en hen in staat stelt om op de hoogte te blijven
              van wat er in hun directe omgeving gebeurt. Met betrouwbare informatie, effectieve
              moderatie en stimulansen voor gebruikersbetrokkenheid, streeft NPO Connect ernaar om
              een waardevolle bron van lokale kennis en verbinding te zijn voor jongeren overal ter
              wereld. Sluit je vandaag nog aan bij NPO Connect en blijf verbonden met wat er echt
              toe doet in jouw buurt.
            </CustomTypography>
          </Box>
        </CustomGridItem>

        <Stack>
          <CustomTypography>NPO Connect demo. Klik op play om de app te zien.</CustomTypography>
          <video controls autoplay loop width={500}>
            <source src={Video} />
          </video>
        </Stack>
      </Grid>

      <Typography variant="h4" mx={2} mt={2}>
        Concepten
      </Typography>

      <Grid
        container
        spacing={{ xs: 4, sm: 4, md: 0 }}
        sx={{
          py: 10,
          px: 2,
        }}
      >
        <CustomGridItem item xs={12} sm={8} md={6} component="section">
          <Box
            component="article"
            sx={{
              px: 4,
            }}
          >
            <Title text={"History Hub"} textAlign={"start"} />
            <CustomTypography>
              Historische personages kunnen als AI-avatars ingezet worden. Dit kan wanneer een
              gebruiker een documentaire wilt kijken. De gebruiker gaat door de app bladeren en komt
              verschillende personages tegen. Een voorbeeld hiervan zou een AI-versie van Anne Frank
              kunnen zijn, die haar eigen verhaal vertelt. Dit zou de gebruiker direct in het
              verhaal trekken en de boodschap veel dieper laten doordringen dan wanneer het door een
              verteller wordt gepresenteerd.
            </CustomTypography>
          </Box>
        </CustomGridItem>

        <Grid item xs={12} sm={4} md={6}>
          <img
            src={historyHubImage}
            alt=""
            style={{
              width: "100%",
            }}
          />
        </Grid>

        <Grid item xs={12} sm={4} md={6}>
          <img
            src={teleTriviaImage}
            alt=""
            style={{
              width: "100%",
            }}
          />
        </Grid>
        <CustomGridItem item xs={12} sm={8} md={6} component="section">
          <Box
            component="article"
            sx={{
              px: 4,
            }}
          >
            <Title text={"TeleTrivia"} textAlign={"start"} />
            <CustomTypography>
              Houd je van spelletjes en quiz-vragen? Met TeleTrivia gaan we een stapje hoger door
              vragen te stellen over de programma's die je bekijkt. Zo wordt het kijken naar
              NPO-programma's niet alleen vermakelijk, maar ook interactief en educatief. Met
              gamified elementen willen wij gebruikers stimuleren om zowel de app als de programma’s
              te bekijken en gebruiken.
            </CustomTypography>
          </Box>
        </CustomGridItem>

        <CustomGridItem item xs={12} sm={8} md={6} component="section">
          <Box
            component="article"
            sx={{
              px: 4,
            }}
          >
            <Title text={"CommuniTV"} textAlign={"start"} />
            <CustomTypography>
              Stel je voor dat je een live chat hebt, terwijl je je favoriete programma bekijkt. Je
              kunt stemmen, discussiëren en je mening delen met andere kijkers, waardoor je een
              gevoel van gemeenschap krijgt en diepgaande gesprekken kunt voeren over de publieke
              waarden die het programma belichaamt. Deze chat zal zich live afspelen in de NPO app
              tijdens een programma en zal ook doorgaan als het programma al is afgelopen. Mensen
              kunnen hier dan samen chatten over het programma dat ze aan het kijken zijn. Deze
              chats worden ook opgeslagen zodat ze later teruggekeken kunnen worden bij bijvoorbeeld
              video on demand.
            </CustomTypography>
          </Box>
        </CustomGridItem>

        <Grid item xs={12} sm={4} md={6}>
          <img
            src={communicTVImage}
            alt=""
            style={{
              width: "100%",
            }}
          />
        </Grid>
      </Grid>

      <Typography variant="h4" mx={2} mt={2}>
        Extra concepten
      </Typography>

      <Grid
        container
        spacing={{ xs: 4, sm: 4, md: 0 }}
        sx={{
          py: 10,
          px: 2,
        }}
      >
        <CustomGridItem item xs={12} sm={8} md={6} component="section">
          <Box
            component="article"
            sx={{
              px: 4,
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: "100%", // Ensure the content fills the whole height
            }}
          >
            <div>
              <Title text={"NPO Groepen"} textAlign={"start"} />
              <CustomTypography>
                Het idee is om groepen binnen de NPO app te maken waarin je kan praten met andere
                gebruikers. Deze groepen kunnen dan bijvoorbeeld zijn voor mensen met interesse in
                koken of voor kijkers van wie is de mol. Deze groepen zullen gemodereerd worden, dus
                er kunnen er niet te veel zijn. Er zal ook een algoritme zijn waar gebruikersgroepen
                worden aangeraden gebaseerd op wat ze graag kijken. Denk hierbij aan de bakkersgroep
                voor fans van heel Holland bakt. Het doel is om mensen te verbinden met
                gelijkgestemden en om een gemeenschap te cultiveren binnen het Nederlandse publiek.
                Deze verbintenis zou ervoor moeten zorgen dat er meer jongeren naar het platform
                gaan, omdat zij ook vaak zoeken naar mensen die hen begrijpen en die hun interesses
                delen. Dit kan op dit moment ook op twitter maar het probleem daarmee is dat je niet
                altijd je doelgroep kan bereiken en daarom is het beter om de groepen binnen NPO te
                gebruiken. Dan weet je zeker dat je met gelijkgestemden aan het praten bent.
              </CustomTypography>
            </div>
          </Box>
        </CustomGridItem>

        <CustomGridItem item xs={12} sm={8} md={6} component="section">
          <Box
            component="article"
            sx={{
              px: 4,
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              height: "100%", // Ensure the content fills the whole height
            }}
          >
            <div>
              <Title text={"NPO Connect"} textAlign={"start"} />
              <CustomTypography>
                Stel je voor dat er iets spannends in jouw woonplaats gebeurt en je bent er als
                eerste bij, je gaat in de NPO app selecteert de Connect tab. Vervolgens ben je live
                aan het uitzenden via de app naar andere jongeren in de buurt. Als gebruiker kan je
                deze app instellen op je eigen woonplaats en up-to-date zijn van je omgeving. Je
                kunt allerlei momenten, gebeurtenissen, etc. delen door middel van video of
                afbeeldingen. Je kunt zo jouw perspectief laten horen en deelnemen aan een levendige
                discussie met andere jongeren. Dit is jouw kans om een stem te hebben en deel uit te
                maken van een groter geheel.
              </CustomTypography>
            </div>
          </Box>
        </CustomGridItem>
      </Grid>
    </>
  );
};

export default Overview;
